export default __webpack_public_path__ + "static/media/evenOddPreview.25848c5f.png";